import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Employees" }
const _hoisted_2 = { class: "Employees__create" }
const _hoisted_3 = { class: "Employees__search" }
const _hoisted_4 = { class: "Employees__list" }

import { computed } from "vue";
import Search from "@/components/ds/search/Search.vue";
import EmployeeCreate from "./EmployeeCreate.vue";
import { useEmployeeStore } from "@/stores/employees";
import EmployeeList from "@/components/pages/employees/EmployeeList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const employeesStore = useEmployeeStore();

const list = computed(() => {
    return employeesStore.sorted;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(EmployeeCreate)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Search, {
        modelValue: _unref(employeesStore).search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(employeesStore).search) = $event)),
        placeholder: "Zoeken..."
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(EmployeeList, { list: list.value }, null, 8, ["list"])
      ])
    ])
  ]))
}
}

})